<script context="module" lang="ts">export { specification } from "./spec";
</script>

<script lang="ts">import GraffitiCardAtom from "../../Core/GraffitiCard/BaseGraffitiAtom.svelte";
</script>

<GraffitiCardAtom _isotope="J1" {...$$restProps} />
